/* eslint-disable @typescript-eslint/no-namespace */
import container, { containerVariants } from './container';
import heading, { headingVariants } from './heading';
import type { Utility } from '../../../types/utility';

export namespace FeatureGrid {
  /** FeatureGrid Component Variant Keys */
  export type ComponentKeys = 'container' | 'heading';

  /** FeatureGrid Components */
  export type Components = {
    /** The FeatureGrid container subcomponent types. */
    Container: Container.Variants;
    /** The FeatureGrid heading subcomponent types. */
    Heading: Heading.Variants;
  };

  /** FeatureGrid Component Variants */
  export type Variants = {
    [CompKey in ComponentKeys]: CompKey extends 'container'
      ? Container.Variants
      : CompKey extends 'heading'
        ? Heading.Variants
        : never;
  };

  /** FeatureGrid Component Variant Modes */
  export type VariantModes = {
    [CompKey in ComponentKeys]: Utility.VariantModes<
      CompKey extends 'container' ? Container.Variants : CompKey extends 'heading' ? Heading.Variants : never
    >;
  };

  /** FeatureGrid Container Component */
  export namespace Container {
    /** FeatureGrid Container Component Variant Keys */
    export type VariantKeys =
      | 'default'
      | 'offset'
      | 'cards'
      | 'resources'
      | 'alternating'
      | 'alternatingReversed'
      | 'variableHeightCards';

    /** FeatureGrid Container Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  export namespace Heading {
    /** FeatureGrid Heading Component Variant Keys */
    export type VariantKeys = 'default' | 'leftAlign' | 'darkBackground';

    /** FeatureGrid Heading Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** FeatureGrid Component Scale Keys */
  export type ScaleKeys = {
    [CompKey in ComponentKeys]: CompKey extends 'container'
      ? Array<`${CompKey}.${Container.VariantKeys}`>
      : CompKey extends 'heading'
        ? Array<`${CompKey}.${Heading.VariantKeys}`>
        : never;
  };
}

const featureGrid = {
  container,
  heading,
};

export const featureGridVariants = {
  container: containerVariants,
  heading: headingVariants,
};

export default featureGrid;
